const ua = (navigator && navigator.userAgent) || '';
const isJDApp = /jdapp/.test(ua);
const appid = 'ce5f2a374face7d0a44ed35577dae678';
const sceneId = 'locService';

// 获取浏览器经纬度
const navigatorGeolocation = () => {
    return new Promise((resolve, reject) => {
        try {
            if ('geolocation' in navigator) {
	              console.log('开始定位H5定位')
                navigator.geolocation.getCurrentPosition(
                    location => {
											  console.log('开始定位H5定位成功')
                        resolve({
                            lon: location.coords.longitude,
                            lat: location.coords.latitude
                        });
                    },
                    e => {
	                      console.log('开始定位H5定位失败')
	                      resolve({});
                    },
                    {
                        timeout: 3000
                    }
                );
            } else {
	            console.log('开始定位H5定位没权限')
	            resolve({});
            }
        } catch (e) {
	          console.log('开始定位H5定位异常')
	          resolve({});
        }
    });
};
// 获取lbs
const getWebLbsLocation = () => {
    return new Promise((resolve, reject) => {
        console.log('🚀 开始定位JDAPP', 'getWebLbsLocation', new Date().getDate());
				setTimeout(_=> reject({}), 2000);
        window.jdlbs.getLatLng({
            appid,
            sceneId, // 新增，必传。场景id
	          timeout: 2000,
            success({
                status,
                param,
                data,
                msg
            }) {
                console.log('🚀 success', data);
                resolve({
                    lon: data.srclng,
                    lat: data.srclat
                });
            },
            fail({
                status,
                param,
                data,
                msg
            }) {
                console.log('🚀 fail', data);
                reject(data);
            }
        });
    });
};

export const getWebLocation = async() => {
    return new Promise((resolve, reject) => {
        try {
            console.log('🚀 isJDApp - 开始定位', isJDApp, new Date().getDate());
            if (isJDApp) {
                getWebLbsLocation().then((res) => {
	                  console.log('定位成功', new Date().getDate())
                    resolve(res);
                }).catch((e) => {
	                  console.log('定位失败', new Date().getDate())
                    reject(e);
                })
            } else {
                console.log('🚀 isWeb', isJDApp);
                navigatorGeolocation().then((res) => {
                    resolve(res);
                }).catch((e) => {
                    reject(e);
                });
            }
        } catch (e) {
            reject(e);
        }
    });
};

export const webHasLocationPermissionWithScene = () => {
    return new Promise((resolve, reject) => {
        if (isJDApp) {
            console.log('🚀 京东APP内 --- start', new Date().getDate());
						setTimeout(_=> resolve(false), 500);
            window.jdlbs.hasLocationPermissionWithScene({
                appid,
                sceneId, // 新增，必传。场景id
	              timeout: 1000,
                success({
                    status,
                    param,
                    data,
                    msg
                }) {
	                  console.log('🚀 hasLocationPermissionWithScene --- success', new Date().getDate());
                    resolve(data.result);
                },
                fail({
                    status,
                    param,
                    data,
                    msg
                }) {
	                console.log('🚀 hasLocationPermissionWithScene --- fail', new Date().getDate());
                    resolve(false);
                }
            });
        } else {
            console.log('🚀 京东APP外');
            resolve(true);
        }
    });
};

export const webRequestLocationPermissionWithScene = () => {
    return new Promise((resolve, reject) => {
        if (isJDApp) {
						setTimeout(_=> resolve(false), 500);
            window.jdlbs.manualReqLocPermWithScene({
                appid,
                sceneId, // 新增，必传。场景id
                success({
                    status,
                    param,
                    data,
                    msg
                }) {
                    resolve(data.result);
                },
                fail({
                    status,
                    param,
                    data,
                    msg
                }) {
                    resolve(false);
                }
            });
        } else {
            resolve(true);
        }
    });
};

export const webGetAddress = () => {
    return new Promise((resolve, reject) => {
        if (isJDApp) {
            window.jdlbs.getAddress({
                appid,
                sceneId, // 新增，必传。场景id
                success({
                    status,
                    param,
                    data,
                    msg
                }) {
                    if (data && data.provinceid) {
                        resolve({
                            provinceName: data.province,
                            provinceId: data.provinceid,
                            cityName: data.city,
                            cityId: data.cityid,
                            latitude: data.srclat,
                            longitude: data.srclng
                        });
                    } else {
                        reject(null);
                    }
                },
                fail({
                    status,
                    param,
                    data,
                    msg
                }) {
                    reject(data);
                }
            });
        } else {
            reject(null);
        }
    });
};

export const withLocation = async() => {
    // 是否有权限
    console.log('🚀 是否有权限');
    if (!await webHasLocationPermissionWithScene()) {
        // 唤起权限
        console.log('🚀 唤起权限', new Date().getDate());
        await webRequestLocationPermissionWithScene();
        return true;
    }
    return true;
};